import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { IamStore } from '../stores/iam.store'
import { Organisation } from './proficloud.interfaces'

@Injectable({
  providedIn: 'root',
})
export class IamService {
  // Convenience array of what's coming through the store
  public organisations: Organisation[]

  constructor(
    public router: Router,
    private iamStore: IamStore
  ) {
    // Always keep track of organisations and current organisation here
    this.iamStore.organisations$.subscribe((organisations) => {
      if (!organisations) {
        return
      }

      this.organisations = organisations
    })
  }

  /**
   * Checks that an organisation ID is inside the current array of organizations
   */
  public isInsideOrganisations(organisationId: string): boolean {
    let foundOrganisation = false
    this.organisations.forEach((organisation) => {
      if (organisation.organizationId === organisationId) {
        foundOrganisation = true
      }
    })
    return foundOrganisation
  }
}
